import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconTrash: TIconComponent = props => (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.996 22H6.004C5.45 22 5 21.55 5 20.996V6H19V20.996C19 21.55 18.551 22 17.996 22Z"
            stroke="#333333"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <mask id="mask0_2659_2791" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="2" y="1" width="20" height="22">
            <path fillRule="evenodd" clipRule="evenodd" d="M2 23H22V1H2V23Z" fill="white" />
        </mask>
        <g mask="url(#mask0_2659_2791)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 6H15V2H9V6Z"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M3 6H21" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 11V17" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 11V17" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </Icon>
);
